import { useQuery } from '@tanstack/react-query';

import { acceso360Client } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

import { TWorkspaceEntity } from '../types';

import { workspaceQueryKeys } from './query-keys';

// The endpoint is read unpaginated; without an explicit `limit` the backend truncates the list.
const WORKSPACES_LIMIT = 2000;

export async function getWorkspaces(): Promise<TWorkspaceEntity[]> {
  return acceso360Client
    .get('/monitoring/api/v1/workspaces', {
      params: { limit: WORKSPACES_LIMIT, fields_exclude: 'schedule,services' },
    })
    .then(({ data }) => data);
}

type QueryFnType = typeof getWorkspaces;

interface UseWorkspacesParams {
  config?: QueryConfig<QueryFnType>;
}

export function useWorkspaces({ config = {} }: UseWorkspacesParams = {}) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: workspaceQueryKeys.workspaceList(),
    queryFn() {
      return getWorkspaces();
    },
  });
}
